import React from 'react';
import './styles.css';
import TransactionList from '../Chart/TransactionList';
import LiveTicker from '../Chart/LiveTicker';
import CryptoMarquee from '../Chart/CryptoMarquee';
import TopUsers from '../Chart/TopUsers';

const Dashboard = ({ userId }) => {
    return (
        <div className='pageCover'>
            <div className='marqueeContainer'>
                {/* Crypto News */}
                <CryptoMarquee />
            </div>

            <div className='flexContainer'>
                <div className='flexItem doughnutChartContainer'>
                    {userId && <TransactionList userId={userId} />} {/* Ensure userId is passed */}
                </div>
                <div className='flexItem doughnutChartContainer'>
                    <TopUsers />
                </div>
            </div>

            <div className='tickerContainer'>
                <LiveTicker />
            </div>
        </div>
    );
};

export default Dashboard;
